/**
 * Contenido comercial de 100 NEW YORK COOKIES PARA FABRICAR Y VENDER.
 *
 * Regla editorial: no se inventan testimonios, compradores, descuentos,
 * precios anteriores, garantías, bonos, escasez ni promesas de ingresos.
 * Los números corresponden exclusivamente a lo que el producto contiene.
 */

export interface Metric {
  value: string
  label: string
}

export interface CatalogBlock {
  id: string
  count: string
  title: string
  body: string
  /** Representación gastronómica de la categoría. */
  image: string
  alt: string
}

export interface Flavor {
  id: string
  name: string
  tag: string
  note: string
  image: string
  alt: string
}

export interface ContentBlock {
  id: string
  title: string
  body: string
}

export interface Faq {
  question: string
  answer: string
}

export const PRODUCT_NAME = '100 New York Cookies'
export const PRODUCT_SUBTITLE = 'Para fabricar y vender'

export const PRICE = {
  current: '8,99',
  currency: 'USD',
  note: 'Pago único · Acceso digital inmediato',
  fx: 'El checkout realiza la conversión a la moneda de tu país.',
}

/** Ancla de la primera revelación de precio. El CTA del hero scrollea acá. */
export const OFFER_ANCHOR = '#oferta'

export const TICKER_ITEMS: string[] = [
  '100 RECETAS',
  '2 TOMOS DIGITALES',
  'CLÁSICAS + RELLENAS + PREMIUM',
  'ACCESO INMEDIATO',
  'PARA FABRICAR Y VENDER',
]

export const HERO_METRICS: Metric[] = [
  { value: '100', label: 'Recetas' },
  { value: '2', label: 'Tomos digitales' },
  { value: '5', label: 'Categorías' },
  { value: '24/7', label: 'Acceso digital' },
]

/** Sección deseo / oportunidad. */
export const DESIRE_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/58f58fcf-19d3-4898-94ca-5b689395f57b.jpg'

/** Elementos gastronómicos decorativos que rompen la grilla con moderación. */
export const DECO_COOKIE =
  'https://cdn.magicpatterns.com/patterns/generated-images/10284444-11e4-4549-808f-41618bf95932.jpg'

export const DECO_CRUMBS =
  'https://cdn.magicpatterns.com/patterns/generated-images/53319911-89bf-4258-a284-646f951c15fd.jpg'

export const DECO_STACK =
  'https://cdn.magicpatterns.com/patterns/generated-images/4c8775ea-6e7b-4b64-b920-8189d0476458.jpg'

export const DESIRE_POINTS: Array<{ id: string; label: string }> = [
  { id: 'gruesas', label: 'Gruesas y gigantes' },
  { id: 'rellenas', label: 'Rellenos que se ven' },
  { id: 'sabores', label: 'Sabores que se piden' },
  { id: 'catalogo', label: 'Listas para catálogo' },
]

export const DESIRE_CLOSER =
  'Nadie compra una cookie por la receta. La compra porque la vio partida al medio y no pudo dejar de mirarla.'

export const CATALOG_BLOCKS: CatalogBlock[] = [
  {
    id: 'clasicas',
    count: '20',
    title: 'Clásicas y comerciales',
    body: 'Las que se venden todos los días. La base de cualquier catálogo de cookies.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/dda2c673-2600-49b5-8db4-1156af17491b.jpg',
    alt: 'Cookie clásica de chocolate chip vista desde arriba.',
  },
  {
    id: 'rellenas',
    count: '25',
    title: 'Rellenas',
    body: 'Corazón fundente, dulce de leche, cremas y ganaches. Las que enamoran al partirse.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/b2a26a64-3e7c-4f96-8739-52177eb110a1.jpg',
    alt: 'Cookie partida al medio con dulce de leche estirándose.',
  },
  {
    id: 'premium',
    count: '20',
    title: 'Premium y gourmet',
    body: 'Combinaciones de alto valor percibido para subir el ticket de tu carta.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d02d8643-4ee5-486e-98a7-f6a3036a24a2.jpg',
    alt: 'Cookie de pistacho abierta con crema verde y pistachos tostados.',
  },
  {
    id: 'populares',
    count: '20',
    title: 'Sabores populares',
    body: 'Chocotorta, Lemon Pie, Red Velvet, cookies & cream y más clásicos irresistibles.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/072aa39f-4445-4da3-8f30-f07febcaafc2.jpg',
    alt: 'Cookie cookies & cream abierta con crema blanca y trozos de galleta.',
  },
  {
    id: 'especiales',
    count: '15',
    title: 'Especiales y visuales',
    body: 'Cookies pensadas para la foto, las fechas especiales y las ediciones limitadas.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/1bd5dd5c-daa4-4b96-88ef-348f48d7ef33.jpg',
    alt: 'Cookie Red Velvet partida con relleno cremoso blanco.',
  },
]

export const FLAVORS: Flavor[] = [
  {
    id: 'dulce-de-leche',
    name: 'Dulce de leche',
    tag: 'Rellena',
    note: 'Corazón de dulce de leche que se estira al partirla.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/b2a26a64-3e7c-4f96-8739-52177eb110a1.jpg',
    alt: 'New York Cookie partida al medio con relleno de dulce de leche estirándose.',
  },
  {
    id: 'pistacho',
    name: 'Pistacho',
    tag: 'Premium',
    note: 'Crema de pistacho y pistachos tostados. Ticket alto.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d02d8643-4ee5-486e-98a7-f6a3036a24a2.jpg',
    alt: 'New York Cookie abierta con relleno de crema de pistacho verde y pistachos tostados.',
  },
  {
    id: 'brownie-fudge',
    name: 'Brownie Fudge',
    tag: 'Chocolate',
    note: 'Doble chocolate con centro fundente de ganache.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6c999f89-2f9c-41a4-8aab-0812dc5e79ad.jpg',
    alt: 'New York Cookie de doble chocolate partida con ganache fundente cayendo.',
  },
  {
    id: 'red-velvet',
    name: 'Red Velvet',
    tag: 'Visual',
    note: 'Rojo intenso y relleno de chocolate blanco.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/1bd5dd5c-daa4-4b96-88ef-348f48d7ef33.jpg',
    alt: 'New York Cookie Red Velvet partida con relleno cremoso blanco.',
  },
  {
    id: 'cookies-cream',
    name: 'Cookies & Cream',
    tag: 'Popular',
    note: 'Galleta de chocolate triturada y crema de vainilla.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/072aa39f-4445-4da3-8f30-f07febcaafc2.jpg',
    alt: 'New York Cookie cookies & cream abierta con crema blanca y trozos de galleta.',
  },
  {
    id: 'lemon-pie',
    name: 'Lemon Pie',
    tag: 'Especial',
    note: 'Curd de limón y merengue tostado arriba.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d5c08300-c18b-43ff-aac1-d526a8324f5e.jpg',
    alt: 'New York Cookie abierta con relleno de curd de limón y merengue tostado.',
  },
]

export const FLAVOR_PILLS: string[] = [
  'Chocolate',
  'Pistacho',
  'Dulce de leche',
  'Red Velvet',
  'Chocotorta',
  'Lemon Pie',
  'Brownie Fudge',
  'Cinnamon Roll',
  'Cookies & Cream',
  'Caramelo',
  'Frutos rojos',
  'Chocolate blanco',
]

/** Sección "el relleno" — el momento de mayor deseo de la página. */
export const STUFFED_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/649576e7-f156-451a-8db3-593156a8113a.jpg'

export const STUFFED_POINTS: string[] = [
  '25 recetas rellenas',
  'Rellenos que no se escapan',
  'Centros fundentes y cremosos',
  'Corte que se ve en la foto',
]

/** Contenido técnico que acompaña a las 100 recetas. */
export const CONTENT_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/08696760-affc-4bdf-a245-ca532d3fb26d.jpg'

/** Pequeños visuales de proceso que acompañan la lista de fundamentos. */
export const CONTENT_TEXTURES: Array<{ id: string; image: string; alt: string }> = [
  {
    id: 'masa',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7311c3e3-6c73-425b-b7b5-9a8f6009da4f.jpg',
    alt: 'Bolas de masa cruda de cookie con trozos grandes de chocolate.',
  },
  {
    id: 'relleno',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6a358651-d0b6-42c0-851c-856f581ceb69.jpg',
    alt: 'Ganache de chocolate y dulce de leche brillante cayendo de una cuchara.',
  },
  {
    id: 'terminacion',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7a67f30c-dec6-43b8-a1b8-25327095419a.jpg',
    alt: 'Cookies gruesas envueltas y apiladas, listas para entregar.',
  },
]

export const CONTENT_BLOCKS: ContentBlock[] = [
  {
    id: 'fundamentos',
    title: 'Fundamentos de fabricación',
    body: 'Cómo se construye una New York Cookie gruesa, alta y con textura, receta tras receta.',
  },
  {
    id: 'masas',
    title: 'Manejo de masas',
    body: 'Trabajo de la masa, descanso, porcionado y armado para que el resultado se repita.',
  },
  {
    id: 'rellenos',
    title: 'Rellenos',
    body: 'Cómo preparar y colocar los rellenos para que queden en el centro y no se escapen.',
  },
  {
    id: 'horneado',
    title: 'Horneado',
    body: 'Puntos de cocción para lograr borde firme y centro tierno en cada variedad.',
  },
  {
    id: 'conservacion',
    title: 'Conservación',
    body: 'Cómo mantener la textura después del horno para que lleguen bien al cliente.',
  },
  {
    id: 'produccion',
    title: 'Producción y terminación',
    body: 'Organización de la producción y terminaciones para que se vean de pastelería premium.',
  },
]

/** Aplicación comercial. */
export const SELL_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/05a39b88-62de-449e-8703-b00dee8fd975.jpg'

export const SELL_STEPS: Array<{ number: string; title: string; body: string }> = [
  {
    number: '01',
    title: 'Elegí la receta',
    body: 'Abrís el tomo, elegís una de las 100 variedades y tenés todo lo que necesitás para prepararla.',
  },
  {
    number: '02',
    title: 'Prepará desde casa',
    body: 'Sin equipamiento industrial: recetas pensadas para hacerse en una cocina común.',
  },
  {
    number: '03',
    title: 'Sumala a tu catálogo',
    body: 'Definís tu combo, tu presentación y tu precio, y la incorporás a lo que ya vendés.',
  },
]

export const SELL_CLOSER =
  'No es un curso para “aprender algún día”. Es un catálogo de 100 productos listo para entrar a producción esta semana.'

/**
 * Reaparición de los dos tomos a mitad de página, para que se vea la cantidad
 * real de material que se recibe. Los subtítulos son los de las propias tapas.
 */
export const TOMOS = [
  {
    id: 'tomo-1',
    label: 'Tomo 1',
    title: 'Recetas clásicas, rellenas y sabores irresistibles',
  },
  {
    id: 'tomo-2',
    label: 'Tomo 2',
    title: 'Sabores especiales, ediciones temáticas y recetas para vender',
  },
]

/** Los 5 bonos digitales de regalo. Portadas y nombres provistos por el cliente. */
export const BONOS = [
  {
    id: 'bono-1',
    name: 'Mapa de inicio rápido: tus primeras 10 cookies para probar y vender',
    image: 'https://cdn.magicpatterns.com/uploads/irwrNghyZBVBg6e5x1qoMM/bono_1.png',
  },
  {
    id: 'bono-2',
    name: 'Checklist anti-fallas para New York Cookies perfectas',
    image: 'https://cdn.magicpatterns.com/uploads/6GExUZRYBbqhXpJvshomoJ/bono_2.png',
  },
  {
    id: 'bono-3',
    name: 'Guía visual de tamaños y porcionado para New York Cookies',
    image: 'https://cdn.magicpatterns.com/uploads/xkxuEZxYL6N1Zyx5bVjA56/bono_3.png',
  },
  {
    id: 'bono-4',
    name: 'Catálogo Express: descripciones listas para presentar tus cookies',
    image: 'https://cdn.magicpatterns.com/uploads/qDWUXAvmTrvUfcwTbfDYcv/bono_4.png',
  },
  {
    id: 'bono-5',
    name: 'Guía de fotos caseras para cookies que venden por los ojos',
    image: 'https://cdn.magicpatterns.com/uploads/mJzQB5URemQ536cSRjcb2p/bono_5.png',
  },
]

/**
 * Resumen compacto de la caja de oferta. El visitante ya recorrió el catálogo,
 * los sabores y el contenido más arriba en la carta.
 */
export const OFFER_SUMMARY: string[] = [
  '2 tomos digitales',
  '100 recetas de New York Cookies',
  'Clásicas, rellenas, premium y especiales',
  'Fundamentos de fabricación y manejo de masas',
  'Rellenos, horneado y conservación',
  'Producción, terminación y acceso inmediato',
  '+ 5 bonos digitales de regalo',
]

export const FAQS: Faq[] = [
  {
    question: '¿Qué recibo exactamente?',
    answer:
      'Recibís los 2 tomos digitales de 100 New York Cookies, con las 100 recetas divididas en clásicas y comerciales, rellenas, premium, sabores populares y especiales, más los fundamentos de fabricación, manejo de masas y rellenos, horneado, conservación, producción y terminación. Además se incluyen 5 bonos digitales de regalo: Mapa de inicio rápido: tus primeras 10 cookies para probar y vender; Checklist anti-fallas para New York Cookies perfectas; Guía visual de tamaños y porcionado para New York Cookies; Catálogo Express: descripciones listas para presentar tus cookies; y Guía de fotos caseras para cookies que venden por los ojos.',
  },
  {
    question: '¿Necesito experiencia en pastelería?',
    answer:
      'No. Cada receta está pensada para seguirse paso a paso desde casa. Los fundamentos de fabricación explican cómo trabajar la masa, el relleno y el horneado para que el resultado se repita.',
  },
  {
    question: '¿Necesito equipamiento industrial?',
    answer:
      'No. Las recetas están pensadas para prepararse en una cocina común, con horno doméstico y utensilios habituales de pastelería.',
  },
  {
    question: '¿Puedo vender las cookies que preparo?',
    answer:
      'Sí. El producto está pensado exactamente para eso: que incorpores las variedades a tu catálogo y las vendas. Tené en cuenta las normas de elaboración y venta de alimentos que correspondan en tu ciudad o país.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Es un producto 100% digital. Al confirmarse la compra obtenés acceso al material y podés abrirlo desde el teléfono, la tablet o la computadora.',
  },
  {
    question: '¿El acceso es inmediato?',
    answer:
      'Sí. Una vez confirmado el pago accedés a los dos tomos y podés empezar a preparar la primera receta el mismo día.',
  },
  {
    question: '¿Sirve si vivo en otro país?',
    answer:
      'Sí. El material está escrito en español y es digital, así que podés acceder desde cualquier país. El precio se muestra en dólares y el checkout realiza la conversión a la moneda de tu país.',
  },
  {
    question: '¿El pago es único?',
    answer:
      'Sí. Es un pago único de USD 8,99 por el acceso a los dos tomos. No hay suscripción ni cargos posteriores.',
  },
]

export const NAV_LINKS: Array<{ label: string; href: string }> = [
  { label: 'El catálogo', href: '#catalogo' },
  { label: 'Sabores', href: '#sabores' },
  { label: 'Contenido', href: '#contenido' },
  { label: 'Vender', href: '#vender' },
  { label: 'Preguntas', href: '#faq' },
]

/** Contactos reales del footer. Sin placeholders ni links que vuelvan al inicio. */
export const BRAND = {
  studio: 'Creativo Digital',
  email: 'atencion.creativodigital@gmail.com',
  instagramHandle: '@creativodigitalstudio',
  instagramUrl: 'https://www.instagram.com/creativodigitalstudio/',
  siteLabel: 'creativodigital.shop',
  siteUrl: 'https://creativodigital.shop/',
}
